// ============================================================
// HrModelCard.js — CarePeople HR model per client (2b-15e).
// 'integrated' = the Registered Manager handles HR tasks themselves (gains the
// disciplinary DBS/LADO safeguarding setter); 'separate' = a dedicated HR person/
// team owns HR-only tasks. Admin-tenant only (D-15e-8) — a client manager cannot
// self-elevate.
// ============================================================

import React, { useCallback, useEffect, useState } from 'react';
import Field from '../../components/Field';
import { toast } from '../../components/Toaster';
import { getClientHrModel, patchClientHrModel } from '../../api/adminClientConfig';
import { translateError } from '../../utils/errorMessages';
import StatusMessage from '../../components/StatusMessage';

export default function HrModelCard({ clientId }) {
  const [hrModel, setHrModel] = useState('separate');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res = await getClientHrModel(clientId);
      setHrModel(res.hrModel || 'separate');
    } catch (err) { setError(translateError(err)); }
    finally { setLoading(false); }
  }, [clientId]);
  useEffect(() => { fetchData(); }, [fetchData]);

  async function submit(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await patchClientHrModel(clientId, hrModel);
      toast.success('HR model saved');
      await fetchData();
    } catch (err) { toast.error(translateError(err)); }
    finally { setSaving(false); }
  }

  if (loading) return <StatusMessage as="p" variant="loading" className="pc-state">Loading…</StatusMessage>;
  if (error)   return <StatusMessage as="p" variant="error" className="pc-state pc-state--error">{error}</StatusMessage>;

  return (
    <form className="pc-form" onSubmit={submit}>
      <Field
        label="HR model"
        required
        help="Integrated — the Registered Manager handles HR tasks themselves (DBS/LADO). Separate — a dedicated HR person or team owns HR-only tasks."
      >
        <select value={hrModel} onChange={(e) => setHrModel(e.target.value)}>
          <option value="separate">Separate (dedicated HR)</option>
          <option value="integrated">Integrated (manager acts as HR)</option>
        </select>
      </Field>
      <div className="pc-actions">
        <button type="submit" className="pc-btn-primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </form>
  );
}
